import { render, staticRenderFns } from "./ItemAdminPeriod.vue?vue&type=template&id=32dc0636&"
import script from "./ItemAdminPeriod.vue?vue&type=script&lang=js&"
export * from "./ItemAdminPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports